export default{
  label:'reset-color',
  onValue:'text-reset',
  offValue:'',
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/reset-color.js